/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { PageApi } from "../clients";
import { wrap } from "../wrap";

export const pageApi = {
  getPage: wrap(PageApi, PageApi.prototype.getPage),
  getSimplePage: wrap(PageApi, PageApi.prototype.getSimplePage),
  getForm: wrap(PageApi, PageApi.prototype.getForm),
  getThanksPage: wrap(PageApi, PageApi.prototype.getThanksPage),
  postPageSecretPassword: wrap(
    PageApi,
    PageApi.prototype.postPageSecretPassword,
  ),
  getServiceTermPage: wrap(PageApi, PageApi.prototype.getServiceTermPage),
};
